import { render, staticRenderFns } from "./Upcharges.vue?vue&type=template&id=5df13f52&scoped=true&lang=pug"
import script from "./Upcharges.vue?vue&type=script&lang=ts"
export * from "./Upcharges.vue?vue&type=script&lang=ts"
import style0 from "./Upcharges.vue?vue&type=style&index=0&id=5df13f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df13f52",
  null
  
)

export default component.exports